// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-type-tag[data-v-104e1364] {\n  width: 52px;\n}\n.item-status[data-v-104e1364] {\n  max-width: 5em;\n}\n.item-status-sent[data-v-104e1364] {\n  max-width: 5em;\n}", ""]);
// Exports
module.exports = exports;
